interface LogoProps {
  className?: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
}

export function Logo({ className = '', size }: LogoProps) {
  const sizeClasses = {
    sm: 'text-lg sm:text-xl',      // Navbar size (default)
    md: 'text-2xl sm:text-3xl',
    lg: 'text-3xl sm:text-4xl',
    xl: 'text-4xl sm:text-5xl'     // Login page size
  }

  const baseSize = size ? sizeClasses[size] : sizeClasses.sm

  return (
    <h1 className={`${baseSize} block text-black text-shadow-pain-blood text-shadow-lg tracking-widest ${className}`}
      style={{
        fontFamily: 'Gloock',
        fontWeight: '800',
        textShadow: '0 0 8px rgb(150, 0, 0), 0 0 16px rgb(150, 0, 0)'
      }}>
      <span style={{ fontSize: '1.5em', display: 'inline' }}>D</span>ark<span style={{ fontSize: '1.3em', display: 'inline' }}>C</span>hat
    </h1>
  )
}
